import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlaystation3Component } from './simple-icons-playstation3.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlaystation3Component ],
    exports:      [ SimpleIconsPlaystation3Component ],
    bootstrap:    []
})
export class SimpleIconsPlaystation3Module {}
